<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.svg" rel="shortcut icon">
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">Revenue Collection by Streams</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item"><a>Reports</a></li>
                      <li class="breadcrumb-item active">Revenue by Streams</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Summary Cards -->
            <div class="row mb-4">
              <div class="col-md-4">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium mb-2">Total Revenue</p>
                        <h4 class="mb-0">{{ formatPrice(totalAmount) }}</h4>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                          <span class="avatar-title">
                            <i class="bx bx-money font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium mb-2">Total Transactions</p>
                        <h4 class="mb-0">{{ numberFormat(totalTransactions) }}</h4>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                          <span class="avatar-title">
                            <i class="bx bx-receipt font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium mb-2">Active Agents</p>
                        <h4 class="mb-0">{{ numberFormat(totalAgents) }}</h4>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                          <span class="avatar-title">
                            <i class="bx bx-user font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main content -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <!-- Header -->
                  <div class="card-header bg-white border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                      <h4 class="card-title mb-0">
                        Revenue by Stream Report
                        <small class="text-muted ms-2">{{ formatDateRange() }}</small>
                      </h4>
                    </div>
                  </div>

                  <!-- Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-end">
                      <div class="col-md-3">
                        <label class="form-label">From Date:</label>
                        <input v-model="dateFrom"
                               class="form-control"
                               type="date"
                               @change="handleDateChange">
                      </div>

                      <div class="col-md-3">
                        <label class="form-label">To Date:</label>
                        <input v-model="dateTo"
                               class="form-control"
                               type="date"
                               @change="handleDateChange">
                      </div>

                      <div class="col-md-3">
                        <label class="form-label">Sub County (Optional):</label>
                        <select class="form-select" v-model="selectedSubCounty" @change="getReportsStreams()">
                          <option value="">All Sub Counties</option>
                          <option v-for="item in subCounties" :key="item.subCountyID" :value="item.subCountyID">
                            {{ item.subCountyName }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-3">
                        <div class="d-grid gap-2">
                          <button @click="exportToCSV()"
                                  type="button"
                                  class="btn btn-success"
                                  :disabled="exporting || streams.length === 0">
                            <i class="bx bxs-file-export font-size-16"></i>
                            <span class="ms-1">{{ exportButtonText }}</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Quick Date Filters -->
                    <div class="mt-3">
                      <div class="btn-group" role="group">
                        <button @click="setDateRange('today')" type="button" class="btn btn-outline-primary btn-sm">Today</button>
                        <button @click="setDateRange('week')" type="button" class="btn btn-outline-primary btn-sm">This Week</button>
                        <button @click="setDateRange('month')" type="button" class="btn btn-outline-primary btn-sm">This Month</button>
                        <button @click="setDateRange('quarter')" type="button" class="btn btn-outline-primary btn-sm">This Quarter</button>
                        <button @click="setDateRange('year')" type="button" class="btn btn-outline-primary btn-sm">This Year</button>
                      </div>
                    </div>
                  </div>

                  <!-- Table -->
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-light">
                        <tr>
                          <th class="text-nowrap">#</th>
                          <th class="text-nowrap">Revenue Stream</th>
                          <th class="text-nowrap text-center">Total Transactions</th>
                          <th class="text-nowrap text-center">Active Agents</th>
                          <th class="text-nowrap text-end">Amount Collected</th>
                          <th class="text-nowrap text-center">% of Total</th>
                          <th class="text-nowrap">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in sortedStreams" :key="index">
                          <td class="text-nowrap">
                            <strong>{{ index + 1 }}</strong>
                          </td>
                          <td>
                            <a @click="gotToAll('reports-sub-county-streams', item)"
                               href="javascript:void(0);"
                               class="text-primary fw-semibold">
                              {{ item.stream }}
                            </a>
                            <small class="text-muted d-block">{{ item.incomeTypePrefix }}</small>
                          </td>
                          <td class="text-center">
                            <span class="badge bg-info">{{ numberFormat(item.transactions) }}</span>
                          </td>
                          <td class="text-center">
                            <span class="badge bg-success">{{ numberFormat(item.agents) }}</span>
                          </td>
                          <td class="text-end">
                            <strong>{{ formatPrice(item.amount) }}</strong>
                          </td>
                          <td class="text-center">
                            <div class="progress" style="height: 20px;">
                              <div class="progress-bar bg-primary"
                                   :style="`width: ${getPercentage(item.amount)}%`">
                                {{ getPercentage(item.amount) }}%
                              </div>
                            </div>
                          </td>
                          <td>
                            <button @click="gotToAll('paid-bills-streams', item)"
                                    class="btn btn-primary btn-sm">
                              View Details
                            </button>
                          </td>
                        </tr>
                        </tbody>
                        <tfoot class="table-dark">
                        <tr>
                          <th colspan="2">
                            {{ numberFormat(streams.length) }} Revenue Streams
                          </th>
                          <th class="text-center">
                            {{ numberFormat(totalTransactions) }}
                          </th>
                          <th class="text-center">
                            {{ numberFormat(totalAgents) }}
                          </th>
                          <th class="text-end">
                            {{ formatPrice(totalAmount) }}
                          </th>
                          <th class="text-center">100%</th>
                          <th></th>
                        </tr>
                        </tfoot>
                      </table>

                      <!-- Loading State -->
                      <div v-if="loading" class="text-center p-5">
                        <div class="spinner-border text-primary mb-3" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <h4>Loading Revenue Data</h4>
                        <p>Fetching revenue stream information...</p>
                      </div>

                      <!-- No Results -->
                      <div v-if="streams.length === 0 && !loading" class="text-center p-5">
                        <img :src="'./assets/images/no-results.png'"
                             class="img-fluid mb-4"
                             alt="No results"
                             style="max-width: 200px;">
                        <h4>No Revenue Data Found</h4>
                        <p>No revenue streams found for the selected date range.</p>
                      </div>
                    </div>
                  </div>

                  <!-- Chart Section -->
                  <div v-if="streams.length > 0" class="card-footer bg-light">
                    <div class="row">
                      <div class="col-12">
                        <h5 class="mb-3">Revenue Distribution</h5>
                        <canvas id="revenueChart" height="80"></canvas>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Alert Toast -->
        <div v-if="alert.success || alert.failed || alert.info"
             class="toast-container position-fixed top-0 end-0 p-3">
          <div class="toast show" role="alert">
            <div class="toast-header" :class="{
              'bg-success text-white': alert.success,
              'bg-danger text-white': alert.failed,
              'bg-info text-white': alert.info
            }">
              <strong class="me-auto">Notification</strong>
              <button type="button" class="btn-close" @click="clearAlerts"></button>
            </div>
            <div class="toast-body">
              {{ message }}
            </div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by County</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
import NavigationBar from "@/components/Navigation";
import { biller, execute } from "@/api";
import router from "@/router";
import moment from "moment";

export default {
  name: "ReportsStreamsPaid",
  components: { NavigationBar },
  data() {
    return {
      // Loading states
      loading: false,
      exporting: false,

      // Filters
      dateFrom: '',
      dateTo: '',
      selectedSubCounty: '',

      // Data
      streams: [],
      subCounties: [],

      // Totals
      totalTransactions: 0,
      totalAmount: 0,
      totalAgents: 0,

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: '',

      // Chart instance
      chartInstance: null
    }
  },
  computed: {
    exportButtonText() {
      return this.exporting ? 'Exporting...' : 'Export to CSV';
    },

    sortedStreams() {
      return [...this.streams].sort((a, b) =>
          parseFloat(b.amount) - parseFloat(a.amount)
      );
    }
  },
  mounted() {
    // Set default date range to current month
    this.setDateRange('month');

    // Load initial data
    this.loadInitialData();
  },
  methods: {
    // Initialize all data
    async loadInitialData() {
      await this.getSubCounties();
      await this.getReportsStreams();
      this.menuAccess();
    },

    // Main data loading method
    async getReportsStreams() {
      this.loading = true;
      this.streams = [];

      try {
        const data = new FormData();
        data.append("function", "getReportsStreamsPaid");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("status", "PAID");

        if (this.selectedSubCounty) {
          data.append("subCountyID", this.selectedSubCounty);
        }

        const response = await execute(data, biller);

        if (response.data.success) {
          this.streams = response.data.data.streams || [];
          this.calculateTotals();
          this.$nextTick(() => {
            this.renderChart();
          });
        } else {
          this.showAlert('failed', response.data.message || 'Failed to load revenue data');
        }
      } catch (error) {
        console.error('Error loading revenue streams:', error);
        this.showAlert('failed', 'An error occurred while loading revenue data');
      } finally {
        this.loading = false;
      }
    },

    // Calculate totals
    calculateTotals() {
      const totals = this.streams.reduce(
          (accumulator, currentStream) => {
            accumulator.totalTransactions += parseInt(currentStream.transactions || 0);
            accumulator.totalAmount += parseFloat(currentStream.amount || 0);
            accumulator.totalAgents += parseInt(currentStream.agents || 0);
            return accumulator;
          },
          {
            totalTransactions: 0,
            totalAmount: 0,
            totalAgents: 0
          }
      );

      this.totalTransactions = totals.totalTransactions;
      this.totalAmount = totals.totalAmount;
      this.totalAgents = totals.totalAgents;
    },

    // Export to CSV
    exportToCSV() {
      if (this.streams.length === 0) {
        this.showAlert('info', 'No data to export');
        return;
      }

      this.exporting = true;

      try {
        const csvContent = this.generateCSVContent();
        this.downloadCSV(csvContent, this.generateFileName());
        this.showAlert('success', `Successfully exported ${this.streams.length} revenue streams to CSV`);
      } catch (error) {
        console.error('Export error:', error);
        this.showAlert('failed', 'Failed to export data');
      } finally {
        this.exporting = false;
      }
    },

    // Generate CSV content
    generateCSVContent() {
      // Define headers
      const headers = [
        'No',
        'Revenue Stream',
        'Stream Code',
        'Total Transactions',
        'Active Agents',
        'Amount Collected',
        'Percentage of Total',
        'Average per Transaction'
      ];

      // Create CSV rows
      const rows = this.sortedStreams.map((item, index) => {
        const avgPerTransaction = item.transactions > 0
            ? (parseFloat(item.amount) / parseInt(item.transactions)).toFixed(2)
            : '0.00';

        return [
          index + 1,
          this.escapeCSV(item.stream || ''),
          this.escapeCSV(item.incomeTypePrefix || ''),
          item.transactions || 0,
          item.agents || 0,
          this.formatNumberForExport(item.amount || 0),
          `${this.getPercentage(item.amount)}%`,
          avgPerTransaction
        ];
      });

      // Add summary row
      rows.push([]);
      rows.push([
        'TOTALS',
        `${this.streams.length} Streams`,
        '',
        this.totalTransactions,
        this.totalAgents,
        this.formatNumberForExport(this.totalAmount),
        '100%',
        this.formatNumberForExport(this.totalAmount / (this.totalTransactions || 1))
      ]);

      // Add metadata
      const metadata = [
        ['REVENUE COLLECTION BY STREAMS REPORT'],
        ['Generated on:', moment().format('DD/MM/YYYY HH:mm:ss')],
        ['Date Range:', `${this.dateFrom} to ${this.dateTo}`],
        ['Sub County:', this.getSubCountyName() || 'All Sub Counties'],
        [],
        ['SUMMARY STATISTICS'],
        ['Total Revenue:', this.formatPrice(this.totalAmount)],
        ['Total Transactions:', this.numberFormat(this.totalTransactions)],
        ['Active Agents:', this.numberFormat(this.totalAgents)],
        ['Number of Streams:', this.streams.length],
        ['Average per Stream:', this.formatPrice(this.totalAmount / (this.streams.length || 1))],
        ['Average per Transaction:', this.formatPrice(this.totalAmount / (this.totalTransactions || 1))],
        [],
        []
      ];

      // Combine metadata, headers, and rows
      const allRows = [...metadata, headers, ...rows];

      // Add performance analysis
      if (this.streams.length > 0) {
        const topStream = this.sortedStreams[0];
        const bottomStream = this.sortedStreams[this.sortedStreams.length - 1];

        allRows.push([]);
        allRows.push(['PERFORMANCE ANALYSIS']);
        allRows.push(['Top Performing Stream:', topStream.stream,
          this.formatPrice(topStream.amount)]);
        allRows.push(['Lowest Performing Stream:', bottomStream.stream,
          this.formatPrice(bottomStream.amount)]);
      }

      // Convert to CSV string
      return allRows.map(row => row.join(',')).join('\n');
    },

    // Utility function to escape CSV values
    escapeCSV(value) {
      if (value === null || value === undefined) return '';

      const stringValue = String(value);

      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }

      return stringValue;
    },

    // Format number for export
    formatNumberForExport(value) {
      const num = parseFloat(value) || 0;
      return num.toFixed(2);
    },

    // Generate filename
    generateFileName() {
      const timestamp = moment().format('YYYYMMDD_HHmmss');
      const dateRange = `${this.dateFrom}_to_${this.dateTo}`;
      return `revenue_streams_report_${dateRange}_${timestamp}.csv`;
    },

    // Download CSV file
    downloadCSV(content, filename) {
      const blob = new Blob(['\ufeff' + content], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    // Get percentage of total
    getPercentage(amount) {
      if (this.totalAmount === 0) return 0;
      return ((parseFloat(amount) / this.totalAmount) * 100).toFixed(1);
    },

    // Date range presets
    setDateRange(preset) {
      const today = moment();

      switch(preset) {
        case 'today':
          this.dateFrom = today.format('YYYY-MM-DD');
          this.dateTo = today.format('YYYY-MM-DD');
          break;
        case 'week':
          this.dateFrom = today.startOf('week').format('YYYY-MM-DD');
          this.dateTo = today.endOf('week').format('YYYY-MM-DD');
          break;
        case 'month':
          this.dateFrom = today.startOf('month').format('YYYY-MM-DD');
          this.dateTo = today.endOf('month').format('YYYY-MM-DD');
          break;
        case 'quarter':
          this.dateFrom = today.startOf('quarter').format('YYYY-MM-DD');
          this.dateTo = today.endOf('quarter').format('YYYY-MM-DD');
          break;
        case 'year':
          this.dateFrom = today.startOf('year').format('YYYY-MM-DD');
          this.dateTo = today.endOf('year').format('YYYY-MM-DD');
          break;
      }

      this.getReportsStreams();
    },

    // Handle date change
    handleDateChange() {
      if (this.dateFrom && this.dateTo) {
        this.getReportsStreams();
      }
    },

    // Format date range for display
    formatDateRange() {
      if (!this.dateFrom || !this.dateTo) return '';
      return `${moment(this.dateFrom).format('MMM DD, YYYY')} - ${moment(this.dateTo).format('MMM DD, YYYY')}`;
    },

    // Load sub counties
    async getSubCounties() {
      try {
        const data = new FormData();
        data.append("function", "getSubCounty");

        const res = await execute(data, biller);
        if (res.data.success) {
          this.subCounties = res.data.data.subCounties || [];
        }
      } catch (e) {
        console.error('Error loading sub-counties:', e);
      }
    },

    // Get sub county name
    getSubCountyName() {
      if (!this.selectedSubCounty) return null;
      const subCounty = this.subCounties.find(sc => sc.subCountyID === this.selectedSubCounty);
      return subCounty ? subCounty.subCountyName : null;
    },

    // Render chart
    renderChart() {
      const canvas = document.getElementById('revenueChart');
      if (!canvas || this.streams.length === 0) return;

      // Destroy existing chart
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      // Prepare data for chart
      const chartData = this.sortedStreams.slice(0, 10); // Top 10 streams

      const ctx = canvas.getContext('2d');

      // Simple bar chart implementation
      const barWidth = canvas.width / (chartData.length * 2);
      const maxAmount = Math.max(...chartData.map(d => parseFloat(d.amount)));
      const scale = (canvas.height - 40) / maxAmount;

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#556ee6';

      chartData.forEach((item, index) => {
        const barHeight = parseFloat(item.amount) * scale;
        const x = (index * 2 + 0.5) * barWidth;
        const y = canvas.height - barHeight - 20;

        ctx.fillRect(x, y, barWidth, barHeight);

        // Draw labels
        ctx.fillStyle = '#000';
        ctx.font = '10px Arial';
        ctx.save();
        ctx.translate(x + barWidth/2, canvas.height - 5);
        ctx.rotate(-Math.PI/4);
        ctx.fillText(item.stream.substring(0, 15), 0, 0);
        ctx.restore();
        ctx.fillStyle = '#556ee6';
      });
    },

    // Navigation
    gotTo(route) {
      router.push(route);
    },

    gotToAll(route, item) {
      const incomeTypePrefix = item.incomeTypePrefix || "NULL";

      sessionStorage.setItem("currentPage", route);
      sessionStorage.setItem("dateTo", this.dateTo);
      sessionStorage.setItem("dateFrom", this.dateFrom);
      sessionStorage.setItem("subCountyName", "");
      sessionStorage.setItem("subCountyID", this.selectedSubCounty || "");
      sessionStorage.setItem("incomeTypeDescription", item.stream || "");
      sessionStorage.setItem("feeDescription", "");
      sessionStorage.setItem("incomeTypePrefix", incomeTypePrefix);

      router.push(route);
    },

    // Utility methods
    formatPrice(value) {
      const num = parseFloat(value) || 0;
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(num);
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num || 0);
    },

    // Alerts
    clearAlerts() {
      this.alert = { success: false, info: false, failed: false };
      this.message = '';
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;

      setTimeout(() => {
        this.clearAlerts();
      }, 5000);
    },

    // Menu access logging
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Reports Streams");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    }
  }
}
</script>

<style scoped>
.mini-stats-wid {
  border-left: 3px solid transparent;
  transition: all 0.3s ease;
}

.mini-stats-wid:hover {
  border-left-color: #556ee6;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.card-header {
  padding: 1rem;
}

.table th {
  font-weight: 600;
  white-space: nowrap;
}

.table td {
  vertical-align: middle;
}

.progress {
  background-color: #f3f3f3;
}

.progress-bar {
  font-size: 0.75rem;
  font-weight: 600;
}

.btn-group .btn {
  font-size: 0.875rem;
}

.toast-container {
  z-index: 9999;
}

.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

canvas {
  max-width: 100%;
}

.form-label {
  font-weight: 600;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>